/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react';
import { Paginator } from 'primereact/paginator';
import { Dropdown } from 'primereact/dropdown';
import { Box, Typography, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';

export enum OrderByEnum {
  NAME = 0,
  TYPE = 1,
  OWNER = 2,
  ADDRESS = 3,
  CREATED_AT = 4,
  DEVICES = 5,
  SHARES = 6
}

const orderByOptions = [
  { label: 'Name', value: OrderByEnum.NAME },
  { label: 'Type', value: OrderByEnum.TYPE },
  { label: 'Owner', value: OrderByEnum.OWNER },
  { label: 'Address', value: OrderByEnum.ADDRESS },
  { label: 'Created At', value: OrderByEnum.CREATED_AT },
  { label: 'Devices', value: OrderByEnum.DEVICES },
  { label: 'Shares', value: OrderByEnum.SHARES }
];

const StyledPaginatorContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(1, 2),
  borderTop: `1px solid ${theme.palette.divider}`
}));

const StyledOrderingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));

export const EnhancedPaginator = ({
  first,
  rows,
  totalRecords,
  rowsPerPageOptions,
  onPageChange,
  orderBy,
  order,
  handleOrderChange,
  handleOrderByChange
}: {
  first: number;
  rows: number;
  totalRecords: number;
  rowsPerPageOptions: number[];
  onPageChange: (event: any) => void;
  orderBy: OrderByEnum;
  order: string;
  handleOrderChange: (order: string) => void;
  handleOrderByChange: (orderBy: OrderByEnum) => void;
}) => {
  const orderByValue = orderBy !== null ? orderBy : OrderByEnum.NAME;

  const isAsc = order === 'asc';

  return (
    <StyledPaginatorContainer>
      <StyledOrderingContainer>
        <Typography variant="body2">Order by:</Typography>
        <Dropdown
          value={orderByValue}
          options={orderByOptions}
          onChange={(e) => handleOrderByChange(e.value)}
          placeholder="Select a field"
          style={{ minWidth: '150px' }}
        />
        <IconButton onClick={() => handleOrderChange(isAsc ? 'desc' : 'asc')}>
          {isAsc ? <ArrowDownward /> : <ArrowUpward />}
        </IconButton>
      </StyledOrderingContainer>

      <Paginator
        first={first}
        rows={rows}
        totalRecords={totalRecords}
        rowsPerPageOptions={rowsPerPageOptions}
        onPageChange={onPageChange}
        template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
        currentPageReportTemplate="{first} - {last} of {totalRecords}"
      />
    </StyledPaginatorContainer>
  );
};
